export const listingPaths = {
  listing: '/listing',
  schedule: '/listing/schedule',
  search: '/listing/search',
};

export const userPaths = {};
